import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DelegatingMutableSet$iterator$1Class;
function DelegatingMutableSet$iterator$1() {
  if (DelegatingMutableSet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.b4n_1 = this$0;
        this.a4n_1 = this$0.c4n_1.u1();
      }
      v1() {
        return this.a4n_1.v1();
      }
      w1() {
        return this.b4n_1.d4n_1(this.a4n_1.w1());
      }
      u6() {
        return this.a4n_1.u6();
      }
    }
    initMetadataForClass($);
    DelegatingMutableSet$iterator$1Class = $;
  }
  return DelegatingMutableSet$iterator$1Class;
}
var DelegatingMutableSetClass;
function DelegatingMutableSet() {
  if (DelegatingMutableSetClass === VOID) {
    class $ {
      constructor(delegate, convertTo, convert) {
        this.c4n_1 = delegate;
        this.d4n_1 = convertTo;
        this.e4n_1 = convert;
        this.f4n_1 = this.c4n_1.v2();
      }
      g4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = this.e4n_1(item);
          destination.n2(tmp$ret$0);
        }
        return destination;
      }
      h4n(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(_this__u8e3s4, 10));
        var _iterator__ex2g4s = _this__u8e3s4.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = this.d4n_1(item);
          destination.n2(tmp$ret$0);
        }
        return destination;
      }
      v2() {
        return this.f4n_1;
      }
      i4n(element) {
        return this.c4n_1.n2(this.e4n_1(element));
      }
      n2(element) {
        return this.i4n((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      j4n(elements) {
        return this.c4n_1.z2(this.g4n(elements));
      }
      z2(elements) {
        return this.j4n(elements);
      }
      f5() {
        this.c4n_1.f5();
      }
      k4n(element) {
        return this.c4n_1.y2(this.e4n_1(element));
      }
      y2(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.k4n((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      l4n(elements) {
        return this.c4n_1.v4(this.g4n(elements));
      }
      v4(elements) {
        return this.l4n(elements);
      }
      s1() {
        return this.c4n_1.s1();
      }
      u1() {
        return new (DelegatingMutableSet$iterator$1())(this);
      }
      hashCode() {
        return hashCode(this.c4n_1);
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !isInterface(other, KtSet());
        }
        if (tmp)
          return false;
        var elements = this.h4n(this.c4n_1);
        var tmp_0;
        if (other.v4(elements)) {
          // Inline function 'kotlin.collections.containsAll' call
          tmp_0 = elements.v4(other);
        } else {
          tmp_0 = false;
        }
        return tmp_0;
      }
      toString() {
        return toString(this.h4n(this.c4n_1));
      }
    }
    initMetadataForClass($, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet()]);
    DelegatingMutableSetClass = $;
  }
  return DelegatingMutableSetClass;
}
//region block: exports
export {
  DelegatingMutableSet as DelegatingMutableSet198sgh8jelkh1,
};
//endregion

//# sourceMappingURL=DelegatingMutableSet.mjs.map
